/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFamilyMemberAllergies = sqliteTable('patient_family_member_allergies', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  family_member_id: text('family_member_id'),
  allergy_type: text('allergy_type'),
  substance: text('substance'),
  reaction: text('reaction'),
  severity: text('severity'),
  notes: text('notes'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
  updated_by: text('updated_by'),
});
